import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { ServiceWorkerModule } from "@angular/service-worker";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";
import { AuthModule } from "./auth/auth.module";
import { CmsModule } from "./cms/cms.module";
import { ComplaintsModule } from "./complaints/complaints.module";
import { AuthService } from "./core/auth.service";
import { CoreModule } from "./core/core.module";
import { CustomSnackbarComponent } from "./custom-snackbar/custom-snackbar.component";
import { HomeModule } from "./home/home.module";
import { PaymentsModule } from "./payments/payments.module";
import { ReportsModule } from "./reports/reports.module";
import { ServicesTypeModule } from "./services-types/servicesType.module";
// import { DateAdaptersModule } from './shared/date-adapters.module';
import { SharedModule } from "./shared/shared.module";
import { UiModule } from "./ui/ui.module";
import { UserCasesModule } from "./user-cases/user-cases.module";
import { UsersModule } from "./users/users.module";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
  //return new TranslateHttpLoader(http,'/admin/assets/i18n/');
}

@NgModule({
  declarations: [AppComponent, CustomSnackbarComponent],
  imports: [
    RouterModule.forRoot([]),
    BrowserModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader, // exported factory function needed for AoT compilation
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    CoreModule,
    AuthModule,
    UiModule,
    SharedModule,
    HomeModule,
    ReportsModule,
    MatSnackBarModule,
    CmsModule,
    UsersModule,
    UserCasesModule,
    PaymentsModule,
    ServicesTypeModule,
    ComplaintsModule,
    // DateAdaptersModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
  ],

  exports: [TranslateModule],
  providers: [AuthService],
  bootstrap: [AppComponent],
})
export class AppModule { }
